<nx-default-box-v2>

  <!-- label -->
  <ng-template nxTemplate="label">
    <div class="text-[1rem] font-medium leading-3r mt-[2px]">
    Zuweisung
    <p-progressSpinner
      ariaLabel="loading"
      *ngIf="isLoading()"
      styleClass="ml-[6px] w-[16px] h-[16px] black-spinner"
      strokeWidth="8"/>
    </div>
  </ng-template>
  
  <!-- content -->
  <ng-container [ngTemplateOutlet]="editMode() ? editTemplate : displayTemplate"></ng-container>
  
  <!-- actions -->
  <ng-template nxTemplate="mainEnd">
    <ng-container [ngTemplateOutlet]="editMode() ? editActionsTemplate : displayActionsTemplate"></ng-container>
  </ng-template>
</nx-default-box-v2>

<!-- content view mode -->
<ng-template #displayTemplate>
  <nx-assignment-display [assignee]="assignee()" />
  @if(task()?.assignmentSuggestion?.assigneeId && (task()?.state === 'UNASSIGNED' || task()?.state === 'NEW')) {
  <div
    class="w-full h-auto rounded border border-gray-300 mt-1">
    <div class="text-[1rem] font-medium leading-3r mt-[2px] text-black px-2 py-1 border-gray-300">
    Vorschlag
    </div>
    <div class="text-base text-[#848488] ng-star-inserted px-2 py-1">
      {{task()?.assignmentSuggestion?.name}}
    </div>
    <div class="flex justify-end border-gray-300 px-2 mb-2">
      <nx-default-button
        [style]="'dark'"
        [label]="'Akzeptieren'"
        (click)="acceptSuggestion()"
        [icon]="'icon-check'">
      </nx-default-button>
    </div>
  </div>
  }
</ng-template>

<!-- content edit mode -->
<ng-template #editTemplate>
  <div class="mt-1" [formGroup]="form">
    <nx-edit-select-v2-input
      [formGroup]="form"
      #selectComponent  
      [placeholder]="'Zuweisung auswählen'"
      [filter]="true"
      [showLabel]="false"
      [panelWidhtFull]="true"
      formControlName="selected"
      [options]="options()"
      [optionGroupLabel]="'label'"
      [optionGroupChildren]="'items'"
      [optionLabel]="'name'"
      [dataKey]="'id'"
      [optionValue]="'id'"
      [showClear]="true">
    </nx-edit-select-v2-input>
  </div>
</ng-template>

<ng-template #displayActionsTemplate>
  <nx-default-button
    [style]="'dark'"
    (click)="edit()"
    [icon]="'icon-edit'"
    [disabled]="commandTemplate()?.settings?.disabled"
    [tooltip]="'Bearbeiten'">
  </nx-default-button>
</ng-template>

<ng-template #editActionsTemplate>
  <nx-default-button
    [style]="'dark'"
    class="mr-1"
    (click)="save()"
    [disabled]="isLoading() || form?.pristine"
    [icon]="'icon-check'"
    [tooltip]="'Speichern'">
  </nx-default-button>
  <nx-default-button
    [style]="'dark'"
    (click)="cancel()"
    [icon]="'icon-cancel'"
    [disabled]="isLoading()"
    [tooltip]="'Abbrechen'">
  </nx-default-button>
</ng-template>
